module.exports = __webpack_public_path__ + "img/header_member.0be9c0fb.svg";